module.exports = __webpack_public_path__ + "static/media/inspired.a59c24ef.png";